<template>
  <Transition name="ui-error">
    <span v-if="message"
          class="ui-error"
          :class="[
            { 'ui-error--inline': inline },
            extraClass,
          ]">{{ message }}</span>
  </Transition>
</template>

<script setup lang="ts">
interface Props {
  /** Текст помилки (вже перекладений або готовий рядок). Якщо пусто — блок не показується. */
  message?: string
  /** Варіант відображення: inline з відступом зверху (наприклад, під чекбоксом). */
  inline?: boolean
  /** Додаткові CSS-класи (наприклад, pt-4). Передавати як extra-class="pt-4". */
  extraClass?: string
}

withDefaults(defineProps<Props>(), {
  message: undefined,
  inline: false,
  extraClass: undefined,
})
</script>

<style scoped>
.ui-error {
  display: block;
  font-size: 13px;
  color: var(--color-error);
  margin-top: 4px;
}

.ui-error--inline {
  margin-top: 4px;
}

/* Плавна поява та зникнення */
.ui-error-enter-active,
.ui-error-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.ui-error-enter-from,
.ui-error-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.ui-error-enter-to,
.ui-error-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
